import { connect } from "react-redux"
import React, { Fragment } from "react"

import AttachmentListItem from "../../../common/AttachmentListItem"
import DefaultListItemShadow from "../../../common/DefaultShadowListItem"
import { range } from "../../../../config/util-functions"

export const InsightAreaMediaViewWidget = ({ media, isFetching }) => (
    <div className="widget">
        <h3 className="widget-header">
            <span className="icon icon-media" />
            Media
        </h3>
        <div className="widget-content list-group items-list">
            {isFetching ? (
                range(3).map(index => <DefaultListItemShadow key={index} />)
            ) : (
                <Fragment>
                    {media.map(item => (
                        <AttachmentListItem
                            thumbnail_url={item.thumbnail_url || item.url}
                            title={item.title}
                            labels={item.labels}
                            provider={item.provider}
                            creator={item.creator}
                            time={item.time}
                            url={item.url}
                            mode="view"
                            key={item.id}
                        />
                    ))}
                    {!media.length && "No media"}
                </Fragment>
            )}
        </div>
    </div>
)

const mapStateToProps = ({
    presentation: { insightAreas },
    entities,
    paging: { topicAttachments },
    authentication
}) => ({
    media: insightAreas.media.map(medium => entities.attachments[medium]),
    isFetching:
        insightAreas.isFetchingItem ||
        (topicAttachments[
            `topic=${insightAreas.activeId}&userid=${authentication.id}`
        ] || { isFetching: true }).isFetching
})

export default connect(mapStateToProps)(InsightAreaMediaViewWidget)
